import img1 from './slider-images/img1.png';
import img2 from './slider-images/img2.jpg';
import img3 from './slider-images/img3.jpg';
import img4 from './slider-images/img4.jpg';
import img5 from './slider-images/img5.jpg';
import img6 from './slider-images/img6.png';

const slides = [
  {
    image: img1,
    quote: `Your dream our passion`,
    bgColor: '#010101'
  },
  {
    image: img2,
    quote: `A timeless collection handcrafted to perfection`,
    bgColor: '#010101'
  },
  {
    image: img4,
    quote: `A little out of the way very much out of the ordinary`,
    bgColor: '#010101'
  },
  {
    image: img3,
    quote: `A scintillating soulmate that'll be yours forever`,
    bgColor: '#010101'
  },
  {
    image: img6,
    quote: `Let your jewellery do the talking for you`,
    bgColor: '#010101'
  },
  {
    image: img5,
    quote: 'Wear something that empowers you',
    bgColor: '#010101'
  },
];

export default slides;